namespace Cfnc {
    "use strict";

    interface IErrSrc extends ng.IDirective {
    }

    interface IErrSrcScope extends ng.IScope {
    }

    class ErrSrc implements IErrSrc {
        static directiveId: string = "errSrc";
        restrict: string = "A";

        constructor() {

        }

        link = ($scope: IErrSrcScope, element, attrs) => {
            element.bind("error",() => {
                if (attrs.src != attrs.errSrc) {
                    attrs.$set("src", attrs.errSrc);
                }
            });

        }

    }

    angular.module("app").directive(ErrSrc.directiveId, [ ()=> new ErrSrc() ]);

} 